const { fetchJsonApi } = require('./abstract');
const { getApiLanguage } = require('./language');
const { REWARDED_VIDEO_LOOTPACK_PLATFORMS } = require('../constants');
const { getProvider, getPlatform } = require('./platform');

function fetchSlots(apiUrl, countryCode) {
  const query = {
    country: countryCode || '',
    platform: getPlatform() || '',
    provider: getProvider() || '',
    lang: getApiLanguage(),
    rewardedVideoLootpack: REWARDED_VIDEO_LOOTPACK_PLATFORMS[getProvider()],
  };
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: 'v3/content-slots',
    query,
    expectedStatus: 200,
    description: 'Fetching Slots',
  });
}

module.exports = {
  fetchSlots,
};
